<template>
  <div class="father">
    <van-nav-bar>
      <template #title>
        <span class="navbar_title">扫码开门</span>
      </template>
    </van-nav-bar>
    <div class="logo_container">
      <van-image width="120" :src="logo_img" />
    </div>
    <div class="qrcode_container">
      <div class="qrcode_container_content">
        <span class="qrcode_span"  @click="refreshQrCode">
          <span class="loading" v-if="isShowLoading"
            ><van-loading type="spinner"
          /></span>
          <qriously v-if="qrcodeData" :value="qrcodeData" :size="250"></qriously
        ></span>
        <div class="qrcode_title">扫码开门</div>
        <div class="qrcode_tips">每30秒自动刷新二维码</div>
      </div>
    </div>
    <!-- <input type="text" v-model="data" /> -->
  </div>
</template>

<script>
import Vue from "vue";
import VueQriously from "vue-qriously";
import { showMsg } from "../../utils/dialog.js";
import { Toast } from "vant";
Vue.use(VueQriously);
export default {
  name: "QRcode",
  data() {
    return {
      qrcodeData: "",
      logo_img: require("../../assets/img/qrcode_logo.png"),
      isShowLoading: false,
    };
  },
  methods: {
    async getQrCodeData() {
      this.isShowLoading = true;
      let res = await this.$store.dispatch("getQrCodeData");
      if (res.success) {
        this.isShowLoading = false;
        this.qrcodeData = res.data;
      } else {
        Toast.fail(res.msg);
      }
    },
    // 刷新二维码
    refreshQrCode() {
      this.getQrCodeData();
      // this.qrcodeData = Math.random().toString();
    },
  },
  mounted() {
    this.refreshQrCode();
    // 每隔30秒刷新一次二维码
    this.timer_qrcode = setInterval(this.refreshQrCode, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer_qrcode);
  },
};
</script>

<style scoped>
.father {
  background-color: WhiteSmoke;
  height: 100vh;
}
.van-nav-bar {
  background-color: #ba3939 !important;
}
.navbar_title {
  color: #ffffff !important;
}
.logo_container {
  display: flex;
  height: 270px;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* border: 1px red solid; */
  box-sizing: border-box;
}
.qrcode_container {
  display: flex;
  justify-content: center;
  height: fit-content;
  width: 100%;
  padding: 0px 40px;
  /* border: 1px red solid; */
  background-color: WhiteSmoke;
  box-sizing: border-box;
}
.qrcode_container_content {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 700px;
  width: 100%;
  padding-top: 30px;
  box-sizing: border-box;
  background-color: #ffffff;
}
.qrcode_span {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 510px;
  width: 500px;
}
.qrcode_title,
.qrcode_tips {
  height: 50px;
  line-height: 50px;
  width: 100%;
  text-align: center;
}
.qrcode_title {
  font-size: 32px;
  font-weight: bold;
  margin-top: 10px;
}
.qrcode_tips {
  height: 50px;
  font-size: 28px;
  margin-top: 5px;
  color: Gray;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100px;
  position: absolute;
  background-color: WhiteSmoke;
  border-radius: 10px;
}
</style>